<template>
    <!-- 首页点击更换老师 -->
    <div class="teacher-herder">
        <div>
            <div v-for="(item, index) in arr" :key="index" :class="conet==item.id ? 'teacher-headers' :'teacher-header'"
                @click="getcont(item)">
                <div>
                    <img :src="item.avatar" alt="" class="teacher-image">
                    <span class="teacher-name">{{ item.name }}</span>
                    <!-- <span class="teacher-xq">详情 <i class="el-icon-arrow-right"></i></span> -->
                </div>
                <div class="teacher-title">
                    {{ item.sentence_marking }}
                </div>
            </div>
            <div class="course-button" @click="gotime">确认</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                const: 0,
                conet: 0,
                teacherconet: 0,
                list: [],
                names: '',
                teacher_id: '',
                arr: []
            }
        },
        mounted() {
            this.const = this.$store.state.teacherId || this.$route.query.id
            this.teacherconet = this.$route.query.homeScheduleid;
            this.teacher_id = this.$route.query.teacher_id

            // this.teacherconet=localStorage.getItem('userCourse_id')
            // console.log(this.teacherconet,'課程id');
            this.getteacherlist()
            this.names = localStorage.getItem('username')
        },
        methods: {
            async getteacherlist() {
                let lists = await this.$http.get('/api/student/teachers?course_system_id=' + this.const)
                this.list = lists.data
                this.list.filter(item => {
                    if (item.id != this.teacher_id) {
                        console.log(item)
                        this.arr.push(item)
                    }
                })
            },
            getcont(e) {
                this.conet = e.id; //点击老师id
                console.log(this.conet, "存点击老师id");
                //存点击老师id
                this.$store.commit("changeTeacherValue", this.conet);
            },
            gotime() {
                this.$router.push({
                    name: "Memberleavefrequency",
                    query: {
                        id: this.conet, //点击选中老师的id
                        homeScheduleid: this.$route.query.homeScheduleid,
                    },
                });

            }
        },
    }
</script>
<style lang="scss">
    .teacher-header {
        position: relative;
        display: inline-block;
        margin: 22px;
        width: 362px;
        height: 198px;
        border-radius: 10px 10px 10px 10px;
        opacity: 1;
        border: 1px solid #E6E8EB;
    }

    .teacher-image {
        position: absolute;
        top: 20px;
        left: 30px;
        width: 58px;
        height: 58px;
        opacity: 1;
        border: 2px solid #FFFFFF;
    }

    .teacher-name {
        position: absolute;
        top: 39px;
        left: 108px;
        display: inline-block;
        width: 70px;
        height: 24px;
        font-size: 20px;
        font-family: Inter-Semi Bold, Inter;
        font-weight: normal;
        color: #000000;
        line-height: 23px;
    }

    .teacher-xq {
        position: absolute;
        top: 42px;
        right: 30px;
        width: 45px;
        height: 12px;
        font-size: 10px;
        font-family: Inter-Regular, Inter;
        font-weight: 400;
        color: #9699A4;
        line-height: 12px;
    }

    .teacher-title {
        position: absolute;
        bottom: 24px;
        left: 30px;
        width: 299px;
        height: 76px;
        font-size: 16px;
        font-family: Inter-Regular, Inter;
        font-weight: 400;
        color: #B8B8B8;
        line-height: 19px;
    }

    .teacher-headers {
        position: relative;
        display: inline-block;
        cursor: pointer;
        margin: 22px;
        width: 362px;
        height: 198px;
        background: #FFF8F6;
        border-radius: 10px 10px 10px 10px;
        opacity: 1;
        border: 1px solid #FC5623;
    }

    .course-button {
        line-height: 30px;
        width: 100px;
        text-align: center;
        background: #fd5624;
        color: #fff;
        position: absolute;
        bottom: 20px;
        left: 44%;
        cursor: pointer;
        right: 50px;
    }

    .teacher-herder {
        padding-bottom: 30px;
        position: relative;
        cursor: pointer;
    }
</style>